// Action for Scribe
import {
  SET_SCRIBE_ACTIVE,
  SET_SCRIBE_ACTIVE_SUCCESS,
  SET_SCRIBE_ACTIVE_FAILURE,
  SHOW_HELP_ICONS,
  SHOW_HELP_ICONS_SUCCESS,
  SHOW_HELP_ICONS_FAILURE,
} from "./actionType";

// Action for Scribe
export const setScribeActive = (payload) => ({
  type: SET_SCRIBE_ACTIVE,
  payload,
});
export const setScribeActiveSuccess = (payload) => ({
  type: SET_SCRIBE_ACTIVE_SUCCESS,
  payload,
});
export const setScribeActiveFailure = (payload) => ({
  type: SET_SCRIBE_ACTIVE_FAILURE,
  payload,
});

//SHOW_HELP_ICONS
export const showHelpIcons = (payload) => ({
  type: SHOW_HELP_ICONS,
  payload,
});
export const showHelpIconsSuccess = (payload) => ({
  type: SHOW_HELP_ICONS_SUCCESS,
  payload,
});
export const showHelpIconsFailure = (payload) => ({
  type: SHOW_HELP_ICONS_FAILURE,
  payload,
});
